
<nav mat-tab-nav-bar class="_toolbar_nav">
  <div class="w-100 px-5">
    <a [routerLink]="['/organizer/profile']">
      <i class="fa-solid fa-user"></i>
      <span>Mon profil</span>
    </a>
  </div>
</nav>
